
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/team",
      function () {
        return require("private-next-pages/about/team/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/team"])
      });
    }
  